import React from "react";
import styled from "styled-components";

const StyledSection = styled.section`
  max-width: 1260px;
  margin: 0 auto;
  padding: 0 clamp(28px, 6vw, 80px) 110px;

  .wrap {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    border-top: 1px solid var(--border-light);
    border-bottom: 1px solid var(--border-light);

    @media (max-width: 920px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 560px) {
      grid-template-columns: 1fr;
    }
  }

  .item {
    padding: 26px 18px 28px;
    position: relative;
  }

  .item:not(:last-child):after {
    content: "";
    position: absolute;
    top: 22px;
    right: 0;
    width: 1px;
    height: calc(100% - 44px);
    background: var(--border-light);
  }

  .value {
    color: var(--text-primary);
    font-size: clamp(28px, 4vw, 40px);
    font-weight: 600;
    letter-spacing: -0.04em;
    margin-bottom: 8px;
  }

  .label {
    color: var(--text-secondary);
    font-size: 14px;
    line-height: 1.7;
    max-width: 240px;
  }

  @media (max-width: 920px) {
    .item:nth-child(2):after {
      display: none;
    }
  }

  @media (max-width: 560px) {
    .item:after {
      display: none !important;
    }
  }
`;

const SignalStrip = () => {
  return (
    <StyledSection>
      <div className="wrap">
        <div className="item">
          <div className="value">3 Universities</div>
          <div className="label">
            Academic background across UTS, UC Davis, and SRM Institute of Science and Technology.
          </div>
        </div>

        <div className="item">
          <div className="value">Multi-role</div>
          <div className="label">
            Positioned across data analysis, software engineering, machine learning, AI, and analytics engineering.
          </div>
        </div>

        <div className="item">
          <div className="value">End-to-end</div>
          <div className="label">
            From messy raw data and business logic to pipelines, dashboards, models, and production-ready systems.
          </div>
        </div>

        <div className="item">
          <div className="value">Global profile</div>
          <div className="label">
            Work and education spanning Australia, the United States, and India with cross-domain technical experience.
          </div>
        </div>
      </div>
    </StyledSection>
  );
};

export default SignalStrip;